import angular from 'angular';
angular.module('cxHttpServices').factory('moneyAccountHttpSvc', ['$http', moneyAccountHttpSvc]);

function moneyAccountHttpSvc($http) {
  var baseUrl = '/api/MoneyAccount/';

  function handleSuccess(response) {
    return response.data;
  }
  return {
    getAccounts: function() {
      return $http.get(baseUrl + 'Get').then(handleSuccess);
    },
    createCashRegister: function(account) {
      return $http.post(baseUrl + 'CreateCashRegister', account).then(handleSuccess);
    },
    createBankAccount: function(account) {
      return $http.post(baseUrl + 'CreateBankAccount', account).then(handleSuccess);
    },
    updateCashRegister: function(account) {
      return $http.get(baseUrl + 'UpdateCashRegister', account).then(handleSuccess);
    },
    updateBankAccount: function(account) {
      return $http.get(baseUrl + 'UpdateBankAccount', account).then(handleSuccess);
    },
    remove: function(accountId) {
      return $http.delete(baseUrl + 'Delete/' + accountId).then(handleSuccess);
    },
  };
}
